export enum IElectionsActionTypes {
    BUILD_NATIONAL_COLUMNS = '@@elections/BUILD_NATIONAL_COLUMNS',
    BUILD_REGIONAL_COLUMNS = '@@elections/BUILD_REGIONAL_COLUMNS',
    BUILD_ELECTION_PRES_COLUMNS = '@@elections/BUILD_ELECTION_PRES_COLUMNS',
    BUILD_ELECTION_LEGIS_NAT_COLUMNS = '@@elections/BUILD_ELECTION_LEGIS_NAT_COLUMNS',
    BUILD_ELECTION_LEGIS_CIR_COLUMNS = '@@elections/BUILD_ELECTION_LEGIS_CIR_COLUMNS',
    BUILD_ELECTION_LEGIS_NAT_COLUMNS_V0 = '@@elections/BUILD_ELECTION_LEGIS_NAT_COLUMNS_V0',
    BUILD_ELECTION_LEGIS_CIR_COLUMNS_V0 = '@@elections/BUILD_ELECTION_LEGIS_CIR_COLUMNS_V0',

    SET_ELECTION_PAGE = '@@elections/SET_ELECTION_PAGE',
    SET_STUDY_TYPE = '@@elections/SET_STUDY_TYPE',
    GET_STUDY_TYPES = '@@elections/GET_STUDY_TYPES',
    GET_STUDY_TYPES_SUCCESS = '@@elections/GET_STUDY_TYPES_SUCCESS',
    GET_CIRCO_LIST = '@@elections/GET_CIRCO_LIST',
    GET_CIRCO_LIST_SUCCESS = '@@elections/GET_CIRCO_LIST_SUCCESS',
    GET_CIRCO_VIRT_LIST = '@@elections/GET_CIRCO_VIRT_LIST',
    GET_CIRCO_VIRT_LIST_SUCCESS = '@@elections/GET_CIRCO_VIRT_LIST_SUCCESS',
    GET_DASHBOARD_ELECTION = '@@elections/GET_DASHBOARD_ELECTION',
    GET_DASHBOARD_ELECTION_SUCCESS = '@@elections/GET_DASHBOARD_ELECTION_SUCCESS',
    GET_DASHBOARD_CIRCONSCRIPTION = '@@elections/GET_DASHBOARD_CIRCONSCRIPTION',
    GET_DASHBOARD_CIRCONSCRIPTION_SUCCESS = '@@elections/GET_DASHBOARD_CIRCONSCRIPTION_SUCCESS',
    SET_ELECTION_TABLE = '@@elections/SET_ELECTION_TABLE',
    GET_XLS_DASHBOARD_ELECTION_DETAIL = '@@elections/GET_XLS_DASHBOARD_ELECTION_DETAIL',
    GET_XLS_DASHBOARD_ELECTION_DETAIL_SUCCESS = '@@elections/GET_XLS_DASHBOARD_ELECTION_DETAIL_SUCCESS',
    GET_XLS_DASHBOARD_ELECTION = '@@elections/GET_XLS_DASHBOARD_ELECTION',
    GET_XLS_DASHBOARD_ELECTION_SUCCESS = '@@elections/GET_XLS_DASHBOARD_ELECTION_SUCCESS',
    GET_XLS_DASHBOARD_CIRCONSCRIPTION = '@@elections/GET_XLS_DASHBOARD_CIRCONSCRIPTION',
    GET_XLS_DASHBOARD_CIRCONSCRIPTION_SUCCESS = '@@elections/GET_XLS_DASHBOARD_CIRCONSCRIPTION_SUCCESS',
    GET_DASHBOARD_ELECTION_DETAIL = '@@elections/GET_DASHBOARD_ELECTION_DETAIL',
    GET_DASHBOARD_ELECTION_DETAIL_SUCCESS = '@@elections/GET_DASHBOARD_ELECTION_DETAIL_SUCCESS',
    SAVE_CIRCO_FILTERS = '@@elections/SAVE_CIRCO_FILTERS',
    GET_XLS_DECLARATION_CSA = '@@elections/GET_XLS_DECLARATION_CSA',
    GET_XLS_DECLARATION_CSA_SUCCESS = '@@elections/GET_XLS_DECLARATION_CSA_SUCCESS',
    GET_DECLARATION_CSA = '@@elections/GET_DECLARATION_CSA',
    GET_DECLARATION_CSA_SUCCESS = '@@elections/GET_DECLARATION_CSA_SUCCESS',
    GET_XLS_DASHBOARD_LEGISLATIV = '@elections/GET_XLS_DASHBOARD_LEGISLATIV',
    GET_XLS_DASHBOARD_LEGISLATIV_SUCCESS = '@@elections/GET_XLS_DASHBOARD_LEGISLATIV_SUCCESS',
    
    GET_TIME_ALLLOCATION = '@@elections/GET_TIME_ALLLOCATION',
    GET_TIME_ALLLOCATION_SUCCESS= '@@elections/GET_TIME_ALLLOCATION_SUCCESS',

    GET_TIME_ALLLOCATION_LEGISLATIVE = '@@elections/GET_TIME_ALLLOCATION_LEGISLATIVE',

    GET_TIME_ALLLOCATION_LEGISLATIVE_NAT_SUCCESS_V0= '@@elections/GET_TIME_ALLLOCATION_LEGISLATIVE_NAT_SUCCESS_V0',
    GET_TIME_ALLLOCATION_LEGISLATIVE_NAT_SUCCESS= '@@elections/GET_TIME_ALLLOCATION_LEGISLATIVE_NAT_SUCCESS',
    GET_TIME_ALLLOCATION_LEGISLATIVE_CIR_SUCCESS_V0= '@@elections/GET_TIME_ALLLOCATION_LEGISLATIVE_CIR_SUCCESS_V0',
    GET_TIME_ALLLOCATION_LEGISLATIVE_CIR_SUCCESS= '@@elections/GET_TIME_ALLLOCATION_LEGISLATIVE_CIR_SUCCESS',

    GET_DETAIL_ETUDE_IDS = '@@elections/GET_DETAIL_ETUDE_IDS',
    GET_DETAIL_ETUDE_IDS_SUCCESS= '@@elections/GET_DETAIL_ETUDE_IDS_SUCCESS',
}
export enum EtudeType {
    PLURALISME = 'pluralisme',
    ELECTION = 'election'
};
export enum ElectionType {
    NATIONAL = 'national',
    CIRCONSCRIPTION = 'circonscription',
    CIRCONSCRIPTION_VIRTUELLE = 'circonscription_virtuelle',
};
export enum EDetailEtudeType {
    PAROLE = "Temps de Parole",
    ANTENNE = "Temps d'Antenne",
    ALL = "TOUS"
};
export enum EDetailEtudeID {
    PAROLE = 231583,//231563, //231583, Antenn: 231582
    ANTENNE = 231582//,//231562,
    //ALL = -1
};
export enum PRESIDENTIEL_ELECTION {
    FIRST_ROUND = 33,
    LAST_ROUND = 36
}
export interface IDetailEtudeType {
    id: EDetailEtudeID;
    name: EDetailEtudeType
}
export const DetailEtudeList:IDetailEtudeType[] = [
    {
        id: -1,//EDetailEtudeID.ALL,
        name: EDetailEtudeType.ALL
    },
    {
        id: EDetailEtudeID.PAROLE,
        name: EDetailEtudeType.PAROLE
    },
    {
        id: EDetailEtudeID.ANTENNE,
        name: EDetailEtudeType.ANTENNE
    }
]
export interface ICircoFilters {
    circo_ids?: number[],
    circo_virt_ids?: number[],
    is_nat: boolean;
}
export interface IElectionsStudyFilters {
    readonly univers?: string;
    readonly limit?: number;
} 
export interface IElectionsStudyType {
    end: string,
    id: number,
    name: string,
    start: string
}
export enum PersonFunction {
    SOUTIEN = 'SOUTIEN',
    CANDIDAT = 'CANDIDAT'
}
export interface IElectionDetailFilters {
    study_type_id: number,
    date_end: Date,
    date_start: Date,
    media_ids: number[],
    program_editor_ids: number[],
    program_type_ids: number[],
    time_slot_end: string,
    time_slot_start: string,
    is_nat?: boolean;
    details_etude_id?: number[],
    detail_etude_id?: number,
    political_group_id?: number,
    person_function?: PersonFunction,
}
export interface IElectionFilters {
    study_type_id: number,
    date_end: Date,
    date_start: Date,
    media_ids: number[],
    media_str: string[],
    program_editor_ids: number[],
    program_editor_str: string[],
    program_type_ids: number[],
    time_slot_end: string,
    time_slot_start: string,
    detail_etude_id?: number[],
    is_nat?: boolean,
}
export interface IPluralismeStudyType {
    id: number;
    name: string;
}
export interface IStudyType {
    elections: IElectionsStudyType[];
    pluralisme: IPluralismeStudyType[];
}
export interface IStudyTypeSimple {
    id: number;
    name: string;
    study_type_id: number;
}
export interface IParoleAntenneIDs {
    PAROLE: number;
    ANTENNE: number;
}
export interface ISubGroupList{
    Header: any;
    Footer?:any;
    accessor?: string;
    id?: any;
    cid?: number | undefined;
    show?: boolean;
    getProps?: () => void
}
export interface IGroupList {
    Header: any;
    Footer?:any;
    headerStyle?:any;
    id?: any;
    accessor?: string;
    cid?: number | undefined;
    columns: ISubGroupList[];
    getProps?: () => void
}
export interface IDataSimple {
    hms: number;
    milliseconds: number;
    percent: number
}
export interface IProgramTypeElection {
    CANDIDAT: IDataSimple
    SOUTIEN: IDataSimple
    TOTAL_EMISSION: IDataSimple
}
export interface ICandidatSoutienSimple {
    CANDIDAT: IDataSimple
    SOUTIEN: IDataSimple
    TOTAL: IDataSimple
}
export interface IPoliticalDataRow {
    AUTRES: ICandidatSoutienSimple,
    EMISSIONS: ICandidatSoutienSimple,
    JOURNAUX: ICandidatSoutienSimple,
    MAGAZINES: ICandidatSoutienSimple,
    TOTAL: ICandidatSoutienSimple,
}
export interface IRowData {
    AUTRES: IProgramTypeElection;
    JOURNAUX: IProgramTypeElection;
    MAGAZINES: IProgramTypeElection;
    NAME?: string;
    TOTAL_GROUPE?: IDataSimple
    TOTAL?: IDataSimple
    REGIM?: string;
}
export interface IDataTime {
    CUMUL?: IDataSimple;
    CANDIDAT?: IDataSimple;
    SOUTIEN?: IDataSimple;
    TOTAL: IDataSimple;
}
export interface IDetailEtudeIdData {
    TOTAL_CUMUL?: IDataSimple;
    TOTAL_SOUTIEN?: IDataSimple;
    TOTAL_CANDIDAT?: IDataSimple;
    datas: {[data_id: number] : IDataTime};
    detail_etude_id: number;
    detail_etude_name: string;
}
export interface IDeclarationCSAFilters {
    study_type_id: number,
    date_end: Date,
    date_start: Date,
    media_ids: number[];
}
export interface IDeclarationDetail {
    A_NOMFICHE: string,
    IDFICHEMEDIA: number,
    B_TYPEEMISSION: string,
    C_DATEEMISSION: string,
    D_HEUREDEBUT: string,
    E_HEUREFIN: string,
    F_TITREEMISSION: string,
    G_INTERVENANT: string,
    H_QUALITE: any,
    I_GROUPEPOLITIQUE: any,
    J_REGIMEPOLITIQUE: any,
    K_CodeElection: string,
    L_CIRCONSCRIPTION: string,
    M_CodeListeElec: string,
    N_TypeIntervenant: string,
    O_SituationIntervernant: string,
    P_CUMULTEMPSPAROLE: string
}
export interface IRow {
    DATA: {[data_id: number] : IRowData}
    NAME: string
}
export interface IROWS {
    [row_id:number]: IRow
}
export interface IDashboardCircoData {
    ROWS: IROWS,
    TOTAL: {[total_id: number] : IRowData}
}
export interface IPoliticalGroupData {
    datas: IDataTime,
    political_group_id: number,
    political_group_name: string,
    political_regime_id: number,
    political_regime_name: string;
}
export interface IPoliticalGroupCircoData extends IPoliticalGroupData{
    person_firstname: string
    idinca_personne: number
}
export interface ITotauxPoliticalGroup {
    total_candidat: IDataSimple;
    total_global: IDataSimple;
    total_soutien: IDataSimple;
}
export interface IDashboardDetails {
    date_end: string;
    date_start: string;
    day: string;
    duration: number;
    duration_hms: string;
    editeur_id: number;
    emission_id: number;
    emission_name: string;
    end_group_person_gmt: string;
    end_regim_group_gmt: string;
    etude_end_gmt: string;
    etude_start_gmt: string;
    media_id: number;
    media_name: string;
    passage_end_gmt: string;
    passage_id: number;
    passage_start_gmt: string;
    person_function: PersonFunction;
    person_id: number
    person_name: string;
    political_group_color: number
    political_group_id: number;
    political_group_name: string;
    political_regim_color: number;
    political_regim_id: number;
    political_regim_name: string;
    program_editor_name: string;
    start_group_person_gmt: string;
    start_regim_group_gmt: string;
    study_detail_id: number;
    study_detail_name: string;
    study_id: number;
    study_type_id: number;
    study_type_name: string;
    time: string;
    typeemission_code: string;
    typeemission_id: number;
    typeemission_name: string;
}
export interface IDataHmsPercent {
    "id": number;
    "data_hms": any[], 
    "data_percent": any[]
}
export interface IDataLegisCirco {
    [etude_name:string]: IDataHmsPercent
}
export interface IElectionsState {
    readonly etude: EtudeType;
    readonly elections_start_date: Date | null;
    readonly elections_end_date: any;
    readonly national_columns: IGroupList[];
    readonly national_data_hms: any[];
    readonly national_data_percent: any[];
    readonly regional_columns: IGroupList[];
    readonly regional_data_hms: any[];
    readonly regional_data_percent: any[];
    readonly regional_data: any[];
    readonly regional_virt_data: any[];
    readonly isElectionChecked: boolean;
    readonly study_types: IStudyType | null;
    readonly elections_study_types: IElectionsStudyType[];
    readonly pluralisme_study_types: IPluralismeStudyType[];
    readonly circonscriptions: IStudyTypeSimple[];
    readonly circonscriptions_nat: IStudyTypeSimple[];
    readonly allCirconscriptionsId: number[];
    readonly allCirconscriptionsStr: string[];
    readonly circonscriptionsVirt: IStudyTypeSimple[];
    readonly allCirconscriptionsVirtId: number[];
    readonly allCirconscriptionsVirtStr: string[];
    readonly elections: any;
    readonly circ_data: any;
    readonly circ_virt_data: any;
    readonly time_allocation_filters: IElectionDetailFilters | null;
    readonly dashboard_elections_filters: IElectionFilters | null;
    readonly dasboardDetailsFilters: IElectionDetailFilters | null;
    readonly isLoadingDetail: boolean;
    readonly dashboardElectionDetail: any;
    readonly election_dashboard_loading: boolean;
    readonly circonscription_dashboard_loading: boolean;
    readonly circonscription_virt_dashboard_loading: boolean;
    readonly study_type_id: number;
    readonly get_circo_list_loading: boolean;
    readonly dashboard_circonscriptions: any;
    readonly tableType: ElectionType;
    readonly xls_dashboard_election: any;
    readonly xls_declaration_csa: any;
    readonly xls_declaration_filters: IDeclarationCSAFilters | null;
    readonly circoFilters: ICircoFilters;
    readonly isDeclarationDetailLoading: boolean;
    readonly decalarion_details: IDeclarationDetail[] | null;
    readonly declarations_csa_filters: IDeclarationCSAFilters | null;
    readonly isElectionsRegionale: boolean;
    readonly isElectionPresedentielle: boolean;
    readonly isElectionsLegislative: boolean;
    readonly timeAllocationsLoading: boolean;
    readonly timeAllocationResults: any | null;
    readonly time_allocation_hms: any[];
    readonly time_allocation_percent: any[];
    readonly elections_legis_loading: boolean;
    readonly elections_legis_nat_results: any | null;
    readonly time_allocation_columns: IGroupList[];
    readonly elections_legis_nat_columns: IGroupList[];
    readonly elections_legis_cir_columns: IGroupList[];
    readonly detail_etude_ids: IParoleAntenneIDs;
    readonly data_legis_circo: IDataLegisCirco | null;
}
